import React from "react";
import Colors from "../../Constants/Colors";

function MaintenanceNotice() {
  return (
    <div
      style={{
        minHeight: "100%",   // fill the viewport vertically
        width: "100%",
        background: `radial-gradient(circle, ${Colors.color10} 60%, ${Colors.color8} 100%)`,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        fontFamily: "'Segoe UI', 'Roboto', sans-serif",
        color: Colors.color1,
      }}
    >
      <div
        style={{
          background: Colors.color5, // translucent white
          padding: "2.5rem 2.2rem",
          borderRadius: "24px",
          boxShadow:
            "0 6px 24px rgba(0,0,0,0.09), 0 1.5px 4px rgba(60, 149, 246, 0.11)",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          maxWidth: "500px",
          width: "98vw",
          animation: "popIn .8s cubic-bezier(.23, 2, .16, 1)",
          border: `1px solid ${Colors.color4}`,
        }}
      >
        <span
          style={{
            display: "inline-block",
            fontSize: "2.7rem",
            color: Colors.color12, // bright primary blue
            marginBottom: "1rem",
            animation: "wiggle 2.4s infinite",
          }}
          aria-label="Under Maintenance"
        >
          🛠️
        </span>
        <h2
          style={{
            color: Colors.color1,           // darkest gray
            fontWeight: 600,
            fontSize: "1.5rem",
            marginBottom: "0.65rem",
            letterSpacing: "0.02em",
            textAlign: "center",
            width: "100%",
          }}
        >
          Site Under Maintenance
        </h2>
        <p
          style={{
            color: Colors.color3,          // medium gray
            fontSize: "1.07rem",
            marginBottom: "0.6rem",
            lineHeight: 1.65,
            textAlign: "center",
            width: "100%",
          }}
        >
          We are currently performing scheduled maintenance.<br />
          We should be back online shortly.
        </p>
        <span
          style={{
            fontWeight: 500,
            color: Colors.color12,         // blue
            fontSize: "1.07rem",
          }}
        >
          Thank you for your patience.
        </span>
      </div>
      <style>
        {`
          @keyframes popIn {
            0% { opacity: 0; transform: scale(0.7);}
            100% { opacity: 1; transform: scale(1);}
          }
          @keyframes wiggle {
            0%, 100% { transform: rotate(-6deg); }
            10% { transform: rotate(6deg);}
            20% { transform: rotate(-3deg);}
            30% { transform: rotate(2deg);}
            40%, 90% { transform: rotate(0);}
          }
        `}
      </style>
    </div>
  );
}

export default MaintenanceNotice;
